export async function getChargebeeInstance(isMobile?: boolean): Promise<any> {
  return new Promise((resolve) => {
    const existingScript = document.getElementById('chargebee-js')
    const initParams = {
      site: `${process.env.CHARGEBEE_SITE}`,
      // Required for the card components used by PaymentFailureDialog to tokenize (ENG-1532).
      // Hosted pages — every other caller of this loader — do not need it, and Chargebee ignores
      // it when it is absent, so passing it here is safe for them.
      //
      // This is the PUBLISHABLE key (`live_...` / `test_...`), which is designed to ship to the
      // browser. It is not CHARGEBEE_KEY, the secret API key the backend uses; that must never
      // reach client code.
      publishableKey: process.env.CHARGEBEE_PUBLISHABLE_KEY,
      iframeOnly: isMobile ?? false
    }
    if (existingScript) {
      const cbInstance = window.Chargebee.init(initParams)
      resolve(cbInstance)
    } else {
      const script = document.createElement('script')
      script.addEventListener('load', async function () {
        const cbInstance = window.Chargebee.init(initParams)
        resolve(cbInstance)
      })
      script.async = false
      script.src = 'https://js.chargebee.com/v2/chargebee.js'
      script.id = 'chargebee-js'
      document.body.appendChild(script)
    }
  })
}
